import { Component, OnInit } from '@angular/core';
import { ToastMessage, ToastService } from 'src/app/core/services/toast.service';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    standalone: false
})
export class ToastComponent implements OnInit {
  toast: ToastMessage | null = null;

  constructor(private toastService: ToastService) {}

  ngOnInit() {
    this.toastService.toast$.subscribe(toast => {
      this.toast = toast;
    });
  }

  close() {
    this.toastService.clear();
  }
}
